export default {
  computed: {
    nicknameClient () {
      const firstName = this.clientInfo.firstName
      const lastName = this.clientInfo.lastName
      const nickname = this.clientInfo.nickName
      const fullName = firstName + ' ' + lastName
      const name = firstName && lastName ? fullName : nickname
      return name
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/clientNickname.js